<template>
  <b-card
    :class="
      `card-custom bgi-no-repeat card-stretch gutter-b bg-image-card card-circuled`
    "
    no-body
    :style="
      `background-image: url(` +
        require('@/assets/images/backgrounds/abstract-2.svg') +
        `);`
    "
  >
    <div class="card-body text-center">
      <a
        href="#"
        class="card-title font-weight-bold text-muted text-hover-primary font-size-h5"
      >
        {{ $t(`messages.dashboard.sessionStatus.${sessionStatus.type}.title`) }}
      </a>
      <div class="font-weight-bold text-success mt-5 mb-3">
        {{ sessionStatus.date }}
      </div>
      <p class="text-dark-75 font-weight-bolder font-size-h5 m-0 pr-9">
        {{
          $t(
            `messages.dashboard.sessionStatus.${sessionStatus.type}.description`
          )
        }}
      </p>
      <b-button
        pill
        variant="light"
        @click="goToDetail"
        class="mt-4 btn-text-dark btn-hover-text-dark"
      >
        {{
          $t(`messages.dashboard.sessionStatus.${sessionStatus.type}.button`)
        }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SessionStatus",
  computed: {
    ...mapGetters("Profile", ["sessionStatus"]),
    ...mapGetters("Constants", ["getConstant"])
  },
  methods: {
    goToDetail() {
      if (this.sessionStatus.type === "pending") {
        if (
          parseInt(this.sessionStatus.raw.familyTypeId) ===
          parseInt(this.getConstant("SURVEYTYPE_KYMATIO_CYBERSECURITY"))
        ) {
          this.activate({
            bot: "cybot",
            next: {
              surveyEntityId: this.sessionStatus.raw.surveyEntityId,
              surveyTypeId: this.sessionStatus.raw.familyTypeId
            }
          });
        } else {
          this.activate({
            surveyEntityId: this.sessionStatus.raw.surveyEntityId
          });
        }
      } else if (this.sessionStatus.type === "soon") {
        this.$router.push({
          name: "Profile"
        });
      } else if (this.sessionStatus.type === "done") {
        this.$router.push({
          name: "TrainingDetail",
          params: { id: this.sessionStatus.raw.surveyEntityId }
        });
      }
    },
    ...mapActions("Chatbot", ["activate"])
  }
};
</script>

<style lang="scss" scoped>
.bg-image-card {
  background-position: right top;
  background-size: 30% auto;
}
</style>
